var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.84625 12.3536C7.04151 12.5488 7.3581 12.5488 7.55336 12.3536C7.74862 12.1583 7.74862 11.8417 7.55336 11.6464L4.4075 8.50059L12.7998 8.50059C13.0759 8.50059 13.2998 8.27673 13.2998 8.00059C13.2998 7.72444 13.0759 7.50059 12.7998 7.50059L4.40633 7.50059L7.55336 4.35355C7.74862 4.15829 7.74862 3.84171 7.55336 3.64645C7.3581 3.45119 7.04151 3.45119 6.84625 3.64645L2.84625 7.64645C2.65099 7.84171 2.65099 8.15829 2.84625 8.35355L6.84625 12.3536Z","fill":"#22202F"}));
}

ArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
